export default function truncateText(text: string | unknown, maxLength: number): string {
  if (typeof text === 'string' && text !== '') {
    if (text.length >= maxLength) {
      const stringArr: string[] = text.split('')
      stringArr.length = maxLength
      return `${stringArr.join('')}...`
    }

    return text
  }

  return ''
}
